import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import VisionBanner from "../../../images/visionbanner.webp";
import ValueBanner from "../../../images/valuebanner.webp";
import OurPeopleBanner from "../../../images/ourpeoplebanner.webp";
import ManagementBanner from "../../../images/managementbanner.webp";
import TrusteeBanner from "../../../images/trusteebanner.webp";
import TheAmcBanner from "../../../images/theamcbanner.webp";
import SponsorBanner from "../../../images/sponsorbanner.webp";
import AuditorsBanner from "../../../images/auditorsbanner.webp";
import CustodianBanner from "../../../images/custodianbanner.webp";
import RegistrarsBanner from "../../../images/registrarsbanner.webp";
import CompanyDetailsBanner from "../../../images/companydetailsbanner.webp";
import whoweare from '../../../images/Inner Page/Who-are-we.jpg'

function AboutBanner(props) {
  const [AboutImgBanner, setAboutBanner] = useState(VisionBanner);
  useEffect(() => {
    if (props.id === 1) setAboutBanner(VisionBanner);
    if (props.id === 2) setAboutBanner(ValueBanner);
    if (props.id === 3) setAboutBanner(OurPeopleBanner);
    if (props.id === 4) setAboutBanner(ManagementBanner);
    if (props.id === 5) setAboutBanner(TrusteeBanner);
    if (props.id === 6) setAboutBanner(TheAmcBanner);
    if (props.id === 7) setAboutBanner(SponsorBanner);
    if (props.id === 8) setAboutBanner(AuditorsBanner);
    if (props.id === 9) setAboutBanner(CustodianBanner);
    if (props.id === 10) setAboutBanner(RegistrarsBanner);
    if (props.id === 11) setAboutBanner(CompanyDetailsBanner);
  }, [props.id]);

  return (
    <>
      <section className="banner-sc download-banner">
        {/* <section className="home-banner-main">
          <Container>
          <Row>
          <Col sm={12}>
          <div className="banner-content">
          <h1>Who We Are</h1>
          
          </div>
          
          </Col>
          </Row>
          </Container>
          </section> */}

               <section className="banner-slider">
            <div className="home-banner-sc">
              <div className="banner-container">
                <img
                  src={whoweare}
                  alt="About Us Banner"
                  className="banner-image"
                  />
                
                {/* Text Overlay on Left Side */}
                <div className="banner-text-overlay">
                  <div className="banner-contents">
                    <h1 className="banner-title">About Us</h1>
                  </div>
                </div>
              </div>
            </div>
</section>
      </section>
    </>
  );
}

export default AboutBanner;
